import { useLocation, useNavigate } from "react-router";
import { useCallback } from "react";

/**
 * URLパスの親セグメントに遷移するフック
 *
 * React Router v6の navigate("..") はルートツリーの親に遷移するため、
 * URLパスベースで親に戻りたい場合はこのフックを使う。
 *
 * 例: /companies/abc123 → /companies
 *     /admin/companies/abc123 → /admin/companies
 */
export function useParentNavigate() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const navigateToParent = useCallback(
    (state?: Record<string, unknown>) => {
      const parentPath = pathname.split("/").slice(0, -1).join("/") || "/";
      navigate(parentPath, { state });
    },
    [navigate, pathname],
  );

  return navigateToParent;
}
